<template>
  <!-- Blob 처리 방식 소스 -->
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" max-width="700px">
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">edit</v-icon>신청사항 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-3"></v-divider>
        <div style="height:calc(80vh - 150px);overflow:auto">
          <v-toolbar dense flat color="white" id="Top_Scroll">
            <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
              협력업체 관리자 신청
            </v-card-subtitle>
          </v-toolbar>
          <v-card outlined tile class="mr-4 ml-4 mt-0 pa-6">
            <v-row>
              <v-col cols="12" class="d-flex">
                본인은 {{sFormatCorpNm}} 업체의 관리자로서 {{$store.state.CustomInfo.SiteNm}} 출입에 따른 보안사고 방지에 철저를 기할 것이며,
                보안사항에 대해 출입 기간은 물론 그 이후라도 외부에 절대 누설되지 않도록 출입자에게 교육시키고 철저히 감독할 것과 만일 위 사항을 위반하였을 때는
                모든 책임이 본인에게 있으며, 방문증 분실로 인한 제재조치, 재발급비용 납부 등을 포함한 회사의 어떠한 조치도 감수할 것을 서약 합니다.
              </v-col>
              <v-col cols="12">
                협력업체 관리자 이행사항<br>
                <div class="pl-6">
                  <div class="d-flex">1.&nbsp;<div>방문증 발급에 필요한 제반 서류의 이상 여부 확인 및 이에 대한 책임</div></div>
                  <div class="d-flex">2.&nbsp;<div>출입 사유 종료 시 즉시 방문증 반납</div></div>
                  <div class="d-flex">3.&nbsp;<div>방문증 발급대상자의 보안 교육 이수 안내</div></div>
                  <div class="d-flex">4.&nbsp;<div>소속직원의 방문증 분실 시 24시간 이내 신고</div></div>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center justify-space-around">
                  <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height:70px"/>
                  <v-checkbox v-model="bPledgeCheck" dense class="mt-2" color="black">
                    <template v-slot:label>
                      <div class="black--text">
                        서약합니다.
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-tabs class="pr-4 pl-4" v-model="bChange" @change="InitializeReq()">
            <v-tab center-active class="text-subtitle-1 font-weight-bold">신규</v-tab>
            <v-tab center-active class="text-subtitle-1 font-weight-bold">변경</v-tab>
          </v-tabs>

          <v-card outlined tile class="ma-4 mt-0 pa-6 pb-2">
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.CustomNickId" label="ID" disabled dense persistent-hint persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.CustomNm" label="이름" disabled dense persistent-hint persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="CustomInfo.Tel" label="휴대전화 번호" disabled dense persistent-hint persistent-placeholder></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card outlined tile class="ma-4 mb-0 essetial_card">
            <v-card-text class="mt-2 mb-2">
              <v-row align="center">
                <v-col cols="12" sm="6" md="6" v-if="bChange == 1">
                  <!-- <v-text-field v-model="editedItem.cChangeCustomNm" @keyup.enter="SearchManagerDialog()" @click:append="SearchManagerDialog()" placeholder="이름으로 검색" append-icon="search" dense persistent-hint persistent-placeholder> -->
                  <v-text-field v-model="editedItem.cChangeCustomNm" @keyup="editedItem.cChangeCustomId = ''" @keyup.enter="SearchManagerDialog()" @click:append="SearchManagerDialog()" placeholder="이름으로 검색" append-icon="search" dense persistent-placeholder hide-details>
                    <template v-slot:label>
                      기존 관리자<strong class="red--text">*</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="editedItem.cManagerState" @change="ResetManagerInfo()" dense mandatory row class="mt-0" style="min-width:230px;">
                    <v-radio :disabled="CustomInfo.Manager == 'M' && bChange == 1 " value="M" label="정 관리자"></v-radio>
                    <v-radio :disabled="CustomInfo.Manager == 'S' && bChange == 1 " value="S" label="부 관리자"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="editedItem.cWork" dense auto-grow rows="1" persistent-placeholder hide-details>
                    <template v-slot:label>
                      {{$store.state.CustomInfo.SiteNm}} 관련 주요 업무<strong class="red--text">*</strong>
                    </template>                
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-toolbar dense flat color="white" class="mt-4">
            <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
              첨부파일
            </v-card-subtitle>
          </v-toolbar>

          <v-card outlined tile class="ma-4 mt-0 mb-8 pa-6 essetial_card">
            <v-row>
              <v-col cols="12">
                <div class="d-flex flex-wrap">
                  <div style="width:150px">
                    사업자 등록증
                  </div>

                  <v-img
                    :aspect-ratio="1/1"
                    :src="sNowPath1"
                    contain
                    class="ml-4 mr-4"
                    style="width:100px"
                    max-width="150px"
                    max-height="150px"
                    id="image"
                  ></v-img>
                  <v-file-input
                    v-on:change="onSelFile(NowSelFile1,1)"
                    v-model="NowSelFile1"
                    class="mt-2 mb-2"
                    accept="image/png"
                    :placeholder="editedItem.cFileNm1"
                    hint="Essential"
                    style="max-width : 230px"
                    persistent-hint
                    dense
                  >
                    <template v-slot:message>
                      <div class="mb-1">JPG,JPEG,PNG,GIF파일만 첨부하세요.</div>
                      <div class="mb-1">최대 10MB 까지 첨부가능 합니다.</div>
                      다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                    </template>
                  </v-file-input>
                </div>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">
                <div class="d-flex flex-wrap">
                  <div style="width:150px">
                    협력업체 관리자<br>
                    보안 서약서<br>
                    <v-btn @click="DownloadFile(2)" dark small>[양식 다운로드]</v-btn>
                  </div>
                  <v-img
                    :aspect-ratio="1/1"
                    :src="sNowPath2"
                    contain
                    class="ml-4 mr-4"
                    style="width:100px"
                    max-width="150px"
                    max-height="150px"
                  ></v-img>
                  <v-file-input
                    v-on:change="onSelFile(NowSelFile2,2)"
                    v-model="NowSelFile2"
                    class="mt-2 mb-2"
                    accept="image/png"
                    :placeholder="editedItem.cFileNm2"
                    hint="Essential"
                    style="max-width : 230px"
                    persistent-hint
                    dense
                  >
                    <template v-slot:message>
                      <div class="mb-1">JPG,JPEG,PNG,GIF파일만 첨부하세요.</div>
                      <div class="mb-1">최대 10MB 까지 첨부가능 합니다.</div>
                      다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                    </template>
                  </v-file-input>
                </div>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">
                <div class="d-flex flex-wrap">
                  <div style="width:150px">
                    위임장<br>
                    <v-btn @click="DownloadFile(3)" dark small>[양식 다운로드]</v-btn>
                  </div>
                  <v-img
                    :aspect-ratio="1/1"
                    :src="sNowPath3"
                    contain
                    class="ml-4 mr-4"
                    style="width:100px"
                    max-width="150px"
                    max-height="150px"
                  ></v-img>
                  <v-file-input
                    v-on:change="onSelFile(NowSelFile3,3)"
                    v-model="NowSelFile3"
                    class="mt-2 mb-2"
                    accept="image/png"
                    :placeholder="editedItem.cFileNm3"
                    hint="Essential"
                    style="max-width : 230px"
                    persistent-hint
                    dense
                  >
                    <template v-slot:message>
                      <div class="mb-1">JPG,JPEG,PNG,GIF파일만 첨부하세요.</div>
                      <div class="mb-1">최대 10MB 까지 첨부가능 합니다.</div>
                      다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                    </template>
                  </v-file-input>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <div align="right" class="pa-4 pt-0">
          <v-divider class="mb-2"></v-divider>
          <v-btn @click="dialog = false;" class="mr-2" text><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="SetChangeManagerLog()" class="ml-2" dark><v-icon class="mr-1">save</v-icon>저장</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <SearchManager ref="SearchManagerRef" @SelectManager="SelectManager"/>
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";

import Util from "../Util.js";
import SearchManager from "../views/SearchManager.vue";

// import SearchCorp from "../views/SearchCorp1.vue";

export default {
  components: {
    SearchManager,
  },
  data: () => ({
    bPledgeCheck : false,
    loading : false,
    dialog : false,
    editedIndex : -1,
    bChange : 0,
    NowSelFile1 : null,
    NowSelFile2 : null,
    NowSelFile3 : null,
    sNowPath1 : "",
    sNowPath2 : "",
    sNowPath3 : "",
    cCorpNm : "",
    editedItem : {
      cReqId : "",
      cWork : "",
      cManagerState : "",
      cReqState : "",
      cChangeCustomNm : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      cChangeCustomId : "",
      cFileNm1 : "",
      cFileNm2 : "",
      cFileNm3 : "",
      cFileId1 : "",
      cFileId2 : "",
      cFileId3 : "",
      cFileB64Data1 : "",
      cFileB64Data2 : "",
      cFileB64Data3 : "",
      cCreateDateTime : "",
    },
    defaulteditedItem : {
      cReqId : "",
      cWork : "",
      cChangeCustomNm : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      cFileNm1 : "",
      cFileNm2 : "",
      cFileNm3 : "",
      cFileId1 : "",
      cFileId2 : "",
      cFileId3 : "",
      cFileB64Data1 : "",
      cFileB64Data2 : "",
      cFileB64Data3 : "",
    },
  }),

  computed: {
    ...mapState(["CustomInfo","zFileType","oManagerSec","oWarrant","FMaxSize3"]),
    sFormatCorpNm () {
      if (this.CustomInfo.Local == "Y") {
        return this.CustomInfo.CorpNmKor
      } else {
        return this.CustomInfo.CorpNmEng
      }
    }
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy(){
    this.RemoveBlobURL();
  },

  methods : {
    async ShowDialog(item,index){
      this.dialog = true
      this.bPledgeCheck = false
      this.editedIndex = index
      // this.editedItem = JSON.parse(JSON.stringify(item));

      this.editedItem = Object.assign({
        cReqId : item.cReqId,
        cChangeCustomId : item.cChangeCustomId,
        cChangeCustomNm : item.cChangeCustomNm == "NONE" ? "" : item.cChangeCustomNm,
        cManagerState : item.cManagerState,
        cReqState : item.cReqState,
        cWork : item.cWork,
        cFileId1 : item.cFileId1,
        cFileId2 : item.cFileId2,
        cFileId3 : item.cFileId3,
        cFileNm1 : this.ChangeNm(item.cFileNm1),
        cFileNm2 : this.ChangeNm(item.cFileNm2),
        cFileNm3 : this.ChangeNm(item.cFileNm3),
      })

      if (this.editedItem.cReqState == "F") {
        this.bChange = 0
      } else {
        this.bChange = 1
      }

      this.NowSelFile1 = this.NowSelFile2 = this.NowSelFile3 = null

      this.sNowPath1 = await this.ChangeBlobData3(true,1,item.cFileId1,this.editedItem.cFileB64Data1)
      this.sNowPath2 = await this.ChangeBlobData3(true,2,item.cFileId2,this.editedItem.cFileB64Data2)
      this.sNowPath3 = await this.ChangeBlobData3(true,3,item.cFileId3,this.editedItem.cFileB64Data3)

      this.RemoveBlobURL();

      setTimeout(() => {
        var element =  document.getElementById("Top_Scroll");
        element.scrollIntoView({behavior : "smooth"})
      }, 10);
    },

    ChangeNm(cFileNm) {
      return cFileNm.length > 21 ? cFileNm.substring(0,19) + " ..." : cFileNm
    },

    async ChangeBlobData3(RefreshData,FileCase,FileId,b64Data) {
      let blob = null

      if (b64Data == "" || RefreshData) {
        var res = await this.DownloadAuthFile(FileId)
        if (res.data.ResultCd == "00") {
          try {
            if (FileCase == 1) this.editedItem.cFileB64Data1 = res.data.Result[0].data
            if (FileCase == 2) this.editedItem.cFileB64Data2 = res.data.Result[0].data
            if (FileCase == 3) this.editedItem.cFileB64Data3 = res.data.Result[0].data

            const response = await fetch(res.data.Result[0].data);
            blob = await response.blob();
          } catch (error) {
            console.error(error);
            return ""
          }

          if (blob) {
            return URL.createObjectURL(blob)
          } else {
            return ""
          }

        } else {
          return ""
        }
      } else {
        try {
          const response = await fetch(b64Data);
          blob = await response.blob();
        } catch (error) {
          console.error(error);
          return ""
        }

        if (blob) {
          return URL.createObjectURL(blob)
        } else {
          return ""
        }
      }
    },

    

    DownloadAuthFile(FileId) {
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        FileId : FileId,
      }
      
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_AUTH_FILE_API, posData , {
          headers: {
            "Authorization": this.CustomInfo.Token,
            'Content-Type': 'multipart/form-data',
          }
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          resolve(null);
          EventBus.$emit("onFileBus",err);
        })
      ));
    },

    RemoveBlobURL(){
      setTimeout(() => {
        window.URL.revokeObjectURL(this.sNowPath1)
        window.URL.revokeObjectURL(this.sNowPath2)
        window.URL.revokeObjectURL(this.sNowPath3)
      }, 1000);
    },

    InitializeReq() {
      this.editedItem.cWork = ""
      this.editedItem.cChangeCustomId = "NONE"
      this.editedItem.cChangeCustomNm = ""
      this.editedItem.cManagerState = "M"

      this.NowSelFile1 = this.NowSelFile2 = this.NowSelFile3 = null
      this.sNowPath1 = this.sNowPath2 = this.sNowPath3 = ""
      this.editedItem.cFileId1 = this.editedItem.cFileId2 = this.editedItem.cFileId3 = "NONE"
      this.editedItem.cFileNm1 = this.editedItem.cFileNm2 = this.editedItem.cFileNm3 = ""
      this.editedItem.cFileB64Data1 = this.editedItem.cFileB64Data2 = this.editedItem.cFileB64Data3 = ""

      this.cCorpNm = Util.ChangeCorpNm(this.CustomInfo)
    },

    SearchManagerDialog() {
      this.$refs.SearchManagerRef.ShowDialog(this.editedItem)
    },

    SelectManager(Selected) {
      this.editedItem.cChangeCustomId = Selected.cCustomId
      this.editedItem.cChangeCustomNm = Selected.cCustomNm
    },

    ResetManagerInfo() {
      this.editedItem.cChangeCustomId = ""
      this.editedItem.cChangeCustomNm = ""
      this.editedItem.cWork = ""

      this.NowSelFile1 = this.NowSelFile2 = this.NowSelFile3 =null
      this.sNowPath1 = this.sNowPath2 = this.sNowPath3 = ""
      this.editedItem.cFileId1 = this.editedItem.cFileId2 = this.editedItem.cFileId3 = "NONE"
      this.editedItem.cFileNm1 = this.editedItem.cFileNm2 = this.editedItem.cFileNm3 = ""
    },

    async onSelFile(NowSelFile,FileCase) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          setTimeout(() => {
            if (FileCase == 1) {
              this.sNowPath1 = ""
              this.NowSelFile1 = null;
            }

            if (FileCase == 2) {
              this.sNowPath2 = ""
              this.NowSelFile2 = null;
            }

            if (FileCase == 3) {
              this.sNowPath3 = ""
              this.NowSelFile3 = null;
            }
          }, 10);

          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          if (FileCase == 1) this.NowSelFile1 = null;  
          if (FileCase == 2) this.NowSelFile2 = null;
          if (FileCase == 3) this.NowSelFile3 = null;
        }, 300);

        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      this.loading = true
      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;

        if (FileCase == 1) this.sNowPath1 = imageData;
        if (FileCase == 2) this.sNowPath2 = imageData;
        if (FileCase == 3) this.sNowPath3 = imageData;

        this.loading = false;
      }
      try {
        this.loading = false;
        reader.readAsDataURL(NowSelFile)
      }
      catch (error) {
        if (FileCase == 1) {
          this.sNowPath1 = await this.ChangeBlobData3(false,1,this.editedItem.cFileId1,this.editedItem.cFileB64Data1);
          setTimeout(() => {
            window.URL.revokeObjectURL(this.sNowPath1);
          }, 100);
        }
        
        if (FileCase == 2) {
          this.sNowPath2 = await this.ChangeBlobData3(false,2,this.editedItem.cFileId2,this.editedItem.cFileB64Data2);
          setTimeout(() => {
            window.URL.revokeObjectURL(this.sNowPath2);
          }, 100);
        }
        if (FileCase == 3) {
          this.sNowPath3 = await this.ChangeBlobData3(false,3,this.editedItem.cFileId3,this.editedItem.cFileB64Data3);
          setTimeout(() => {
            window.URL.revokeObjectURL(this.sNowPath3);
          }, 100);
        }
        this.loading = false;
        EventBus.$emit("onFileBus", true,""+error);
      }
    },

    DownloadFile(DownCase) {
      let FilePath = ""
      let FileNm = ""

      if (DownCase == 2) {
        FilePath = this.oManagerSec.FilePath
        FileNm = this.oManagerSec.FileNm
      } else {
        FilePath = this.oWarrant.FilePath
        FileNm = this.oWarrant.FileNm
      }

      window.open(FilePath, '_blank').focus();

      if (DownCase == 2) {
        FilePath = this.oManagerSec.FilePath
        FileNm = this.oManagerSec.FileNm
      } else {
        FilePath = this.oWarrant.FilePath
        FileNm = this.oWarrant.FileNm
      }

      axios({
        url: process.env.VUE_APP_FILE_API + FilePath,
        method: 'GET',
        responseType: 'blob', 
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', FileNm); 
          document.body.appendChild(link);
          link.click();
        });      
    },

    bSendSvrFile(NowSelFile){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadauthfile', NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadAuthFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+NowSelFile.type+"&Size="+NowSelFile.size+"&FileTypeId="+sFileTypeId+"&CustomId="+this.CustomInfo.CustomId+"&SiteId="+this.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  // "Authorization" : this.CustomInfo.Token,
                  'Content-Type' : 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve({data : {ResultCd : "99"}});
              EventBus.$emit("onShowMsg",true, "파일저장에 실패하였습니다. 관리자에게 문의 바랍니다." + err)
          })
      ));
    },

    async SetChangeManagerLog(){
      if (!this.bPledgeCheck) {
        EventBus.$emit("onShowMsgBox", "관리자 서약서에 서약 해주세요.", "서약하기 옆의 체크박스를 클릭해 주세요.");
        return
      }
      if ((this.editedItem.cChangeCustomId == "" || this.editedItem.cChangeCustomId == "NONE") && this.bChange == 1) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "기존 관리자를 선택 하여 주세요.");
        return
      }
      if (this.editedItem.cWork == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.", "{{$store.state.CustomInfo.SiteNm}} 관련 주요 업무를 입력 하여 주세요.");
        return
      }

      if (this.NowSelFile1 == null && this.editedItem.cFileId1 == "NONE") {
        EventBus.$emit("onShowMsgBox", "사진을 첨부하여 주세요.", "사업자 등록증을 첨부하여 주세요.");
        return
      }
      if (this.NowSelFile2 == null && this.editedItem.cFileId2 == "NONE") {
        EventBus.$emit("onShowMsgBox", "사진을 첨부하여 주세요.", "보안 서약서를 첨부하여 주세요.");
        return
      }
      if (this.NowSelFile3 == null && this.editedItem.cFileId3 == "NONE") {
        EventBus.$emit("onShowMsgBox", "사진을 첨부하여 주세요.", "위임장을 첨부하여 주세요.");
        return
      }

      this.loading = true;

      if (this.NowSelFile1 != null) {
        var res1 = await this.bSendSvrFile(this.NowSelFile1);
        if (res1.data.ResultCd == "00") {
          this.editedItem.cFileId1 = res1.data.FileId;
          this.editedItem.cFileNm1 = res1.data.FileNm;
          // this.editedItem.cFilePath1 = res1.data.ThumbnailFilePath;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      if (this.NowSelFile2 != null) {
        var res2 = await this.bSendSvrFile(this.NowSelFile2);
        if (res2.data.ResultCd == "00") {
          this.editedItem.cFileId2 = res2.data.FileId;
          this.editedItem.cFileNm2 = res2.data.FileNm;
          // this.editedItem.cFilePath2 = res2.data.ThumbnailFilePath;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      if (this.NowSelFile3 != null) {
        var res3 = await this.bSendSvrFile(this.NowSelFile3);
        if (res3.data.ResultCd == "00") {
          this.editedItem.cFileId3 = res3.data.FileId;
          this.editedItem.cFileNm3 = res3.data.FileNm;
          // this.editedItem.cFilePath3 = res3.data.ThumbnailFilePath;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      if (this.bChange == 1) {
        this.editedItem.cReqState = "S"
      } else {
        this.editedItem.cChangeCustomId = "NONE"
        this.editedItem.cReqState = "F"
      }

      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CustomNickId : this.CustomInfo.CustomNickId,
        CustomNm : this.CustomInfo.CustomNm,
        Manager : this.CustomInfo.Manager,
        CorpId : this.CustomInfo.CorpId,
        CorpNm : Util.ChangeCorpNm3Data(this.CustomInfo.Local,this.CustomInfo.CorpNmKor,this.CustomInfo.CorpNmEng),
        Tel : this.CustomInfo.Tel,
        Local  : this.CustomInfo.Local,
        CorpNmKor  : this.CustomInfo.CorpNmKor,
        CorpNmEng  : this.CustomInfo.CorpNmEng,
        ReqId : this.editedItem.cReqId,
        Work : this.editedItem.cWork,
        ChangeCustomId : this.editedItem.cChangeCustomId,
        ChangeCustomNm : this.editedItem.cChangeCustomNm,
        ManagerState : this.editedItem.cManagerState,
        ReqState  : this.editedItem.cReqState,
        FileId1 : this.editedItem.cFileId1,
        FileId2 : this.editedItem.cFileId2,
        FileId3 : this.editedItem.cFileId3,
      };
      
      axios
        .post(process.env.VUE_APP_UIL_API + "SetChangeManagerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          this.bPledgeCheck = false;
          this.loading = false;
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            EventBus.$emit("onShowMsg",false,  "수정이 완료되었습니다.");
            this.$emit("ChangeReq", this.editedItem, this.editedIndex)
            this.dialog = false;
            this.RemoveBlobURL();
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd == "04") {
            EventBus.$emit("onShowMsgBox","관리자가 결재 내역을 바꾸었습니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd == "05") {
            EventBus.$emit("onShowMsgBox", "신청 가능한 최대 인원수를 넘었습니다.", res.data.Msg);
          } else if (res.data.ResultCd == "08") {
            EventBus.$emit("onShowMsgBox", "선택하신 관리자에 대하여 변경 진행 중인 결재건이 있습니다.", "소속업체의 관리자나 직원에게 변경 진행 중인 신청건이 있는지 확인하여 주세요.");
          } else if (res.data.ResultCd == "09") {
            EventBus.$emit("onShowMsgBox", "관리자 권한이 해지된 사용자 입니다.", "변경을 원하시는 관리자를 선택하여 주세요.");
          } else if (res.data.ResultCd == "10") {
            EventBus.$emit("onShowMsgBox", "관리자 권한이 변동되었습니다.", "화면을 다시 접속하여 확인 하여 주세요.");
          } else if (res.data.ResultCd == "11") {
            EventBus.$emit("onShowMsgBox", "선택하신 관리자는 삭제된 회원 입니다.", "새로운 관리자를 선택하여 주세요.");
          } else if (res.data.ResultCd == "12") {
            EventBus.$emit("onShowMsgBox", "신규 신청이 불가 합니다.", "신규 신청을 원하시면 관리자 권한에 대한 해지 절차를 진행 하여 주세요.");
          } else if (res.data.ResultCd == "14") {
            EventBus.$emit("onShowMsgBox", "기존에 신청 중인 내역이 존재 합니다.", "신청 중인 건을 삭제 하거나 결재가 완료한 후 신청을 진행하여 주세요.");
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          this.loading = false;
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>